import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, CheckCircleIcon, PlayIcon } from 'lucide-react';
// Last active course (most recently accessed)
const lastActiveCourse = {
  id: 1,
  title: 'Climate Change 101: cosa dice la scienza',
  module: 'Modulo 2 di 3',
  progress: 65,
  timeLeft: '1h 30m rimanenti',
  lessonsCompleted: '8/12 attività completate',
  image: 'https://www.innovationnewsnetwork.com/wp-content/uploads/2020/03/image-1.jpg',
  status: 'IN CORSO'
};
const CourseProgressWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-100 overflow-hidden" data-id="element-1257">
      <div className="p-5" data-id="element-1258">
        <div className="flex justify-between items-center mb-5" data-id="element-1259">
          <h2 className="text-base font-normal text-gray-900" data-id="element-1260">
            Ultimo Corso Aperto
          </h2>
        </div>

        <div className="flex flex-col md:flex-row mb-6 gap-5" data-id="element-1261">
          <div className="w-full md:w-2/5 aspect-video rounded-lg overflow-hidden relative group" data-id="element-1262">
            <img src={lastActiveCourse.image} alt={lastActiveCourse.title} className="w-full h-full object-cover rounded-lg transition-transform duration-500 group-hover:scale-105" data-id="element-1263" />
            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center" data-id="element-1264">
              <Link to={`/corso/${lastActiveCourse.id}`} style={{
              borderRadius: '100px'
            }} className="w-16 h-16 bg-black/30 backdrop-blur-md flex items-center justify-center cursor-pointer hover:bg-black/40 transition-all hover:scale-110" data-id="element-1265">
                <PlayIcon size={28} className="text-white ml-1" strokeWidth={1.5} data-id="element-1266" />
              </Link>
            </div>
          </div>

          <div className="w-full md:w-2/3 flex flex-col justify-between items-start" data-id="element-1267">
            <div data-id="element-1268">
              <div className="mb-4" data-id="element-1269">
                <h3 className="font-normal text-gray-900 text-lg line-clamp-1" data-id="element-1270">
                  {lastActiveCourse.title}
                </h3>
                <p className="text-sm text-gray-500 font-normal" data-id="element-1271">
                  {lastActiveCourse.module}
                </p>
              </div>

              <div className="mb-2 flex justify-between text-sm font-normal" data-id="element-1272">
                <span className="text-gray-600" data-id="element-1273">Progresso</span>
                <span className="text-gray-900" data-id="element-1274">
                  {lastActiveCourse.progress}%
                </span>
              </div>

              <div className="w-full bg-gray-100 h-1.5 mb-4" style={{
              borderRadius: '100px'
            }} data-id="element-1275">
                <div className="bg-green-600 h-full transition-all duration-500" style={{
                width: `${lastActiveCourse.progress}%`,
                borderRadius: '100px'
              }} data-id="element-1276"></div>
              </div>

              <div className="flex flex-col sm:flex-row justify-between text-sm font-normal mb-4 gap-2 sm:gap-0" data-id="element-1277">
                <div className="flex items-center text-gray-600" data-id="element-1278">
                  <ClockIcon size={16} className="mr-1" strokeWidth={1.5} data-id="element-1279" />
                  <span data-id="element-1280">{lastActiveCourse.timeLeft}</span>
                </div>
                <div className="flex items-center text-gray-600" data-id="element-1281">
                  <CheckCircleIcon size={16} className="mr-1" strokeWidth={1.5} data-id="element-1282" />
                  <span data-id="element-1283">{lastActiveCourse.lessonsCompleted}</span>
                </div>
              </div>
            </div>

            <Link to={`/corso/${lastActiveCourse.id}`} className="inline-flex w-fit max-w-max self-start items-center justify-center px-6 py-2.5 bg-green-600 hover:bg-green-700 text-white font-normal transition-colors text-sm" style={{
            borderRadius: '100px'
          }} data-id="element-1284">
              <PlayIcon size={16} className="mr-2" strokeWidth={1.5} data-id="element-1285" />
              Continua a Studiare
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default CourseProgressWidget;